module.exports = __webpack_public_path__ + "static/img/QLD-12.320002d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-12.jpg
// module id = RW4V
// module chunks = 0